import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { filter, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SingleActionDialogComponent } from '../components/dialogs/single-action-dialog/single-action-dialog.component';
import { SKIP_AUTH } from '../tokens/http-context.tokens';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = '';
  private isDialogOpen = false;

  appVersion = '';

  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private http: HttpClient,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private router: Router,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private dialog: MatDialog
  ) {}

  /**
   * 初始化版本檢查：
   * 1. 啟動時記住當前版本
   * 2. 每次路由切換時比對 version.json 是否有新版本
   */
  init(): void {
    // 先取得當前版本，確認後才開始監聽路由切換
    this.fetchVersion().then(version => {
      this.currentVersion = version;
      this.appVersion = version;
      console.log('[VersionCheck] 當前版本:', version);

      // 版本確定後才註冊路由監聽，避免 race condition
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          switchMap(() =>
            this.http.get<{ version: string }>(
              `/assets/version.json?t=${Date.now()}`,
              {
                context: new HttpContext().set(SKIP_AUTH, true),
              }
            )
          )
        )
        .subscribe({
          next: res => {
            // 如果初始取版本失敗，用第一次路由取到的版本補上
            if (!this.currentVersion && res?.version) {
              this.currentVersion = res.version;
              return;
            }
            console.log('✅目前最新版本', res?.version);
            if (
              res?.version &&
              this.currentVersion &&
              res.version !== this.currentVersion &&
              !this.isDialogOpen
            ) {
              console.log(
                '[VersionCheck] 偵測到新版本:',
                res.version,
                '(當前:',
                this.currentVersion,
                ')'
              );
              this.showUpdateDialog();
            }
          },
          error: err => {
            console.warn('[VersionCheck] 無法取得版本資訊:', err.status);
          },
        });
    });
  }

  private async fetchVersion(): Promise<string> {
    try {
      const res = await this.http
        .get<{ version: string }>(`/assets/version.json?t=${Date.now()}`, {
          context: new HttpContext().set(SKIP_AUTH, true),
        })
        .toPromise();
      return res?.version ?? '';
    } catch {
      return '';
    }
  }

  private showUpdateDialog(): void {
    this.isDialogOpen = true;
    const dialogRef = this.dialog.open(SingleActionDialogComponent, {
      disableClose: true,
      data: {
        title: '系統已更新',
        message: '偵測到新版本，請重新整理頁面以獲得最新功能。',
        buttonText: '立即更新',
        showCloseButton: false,
        action: () => {
          dialogRef.close();
          window.location.reload();
        },
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }
}
